<template>
  <van-pull-refresh
    v-model="isLoading"
    class="nd-pulldown"
    :head-height="computeHeight"
    @refresh="refreshHandler"
  >
    <div ref="page" class="inner-page">
      <slot />
    </div>
  </van-pull-refresh>
</template>
<script>
export default {
  name: 'NdPulldown',
  props: {
    refresh: {
      type: Function,
      default: () => new Promise(resolve => {
        setTimeout(() => {
          resolve(true)
        }, 100000)
      })
    }
  },
  data () {
    return {
      isLoading: false,
      computedHeight: 120
    }
  },
  created () {
    this.computeHeight = document.documentElement.style.fontSize.replace('px', '') * 1.2
  },
  methods: {
    async refreshHandler () {
      await this.refresh()
      this.isLoading = false
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.nd-pulldown {
  flex: 1;
  height: 100%;
  overflow-y: scroll;
  /deep/.van-pull-refresh__track {
    min-height: 100%;
    height: auto;
    .van-pull-refresh__head {
      font-size: 28px;
      .van-loading__text {
        color: #999999;
        font-size: 28px;
      }
      .van-loading__spinner {
        width: 28px !important;
        height: 28px !important;
        color: #999999 !important;
      }
    }
  }
  .inner-page{
    min-height: 100%;
    height: auto;
    position: absolute;
    left: 0;
    right: 0;
  }
}
</style>
